export class StorageResource {

  _storage = localStorage;

  constructor(private _storageKey: string) {
  }

  load() {
    const data = this._storage.getItem(this._storageKey) as any;
    return new Promise((resolve) => resolve(JSON.parse(data)));
  }

  save(data) {
    this._storage.setItem(this._storageKey, JSON.stringify(data));
    return new Promise((resolve) => resolve(data));
  }

}